import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { PlusIconWhite } from '../../ui/icons';
import { useSpinner } from '../../../customHooks';
import { useCreateNewOrgAdmin } from './useCreateNewOrgAdmin';

function Modal4CreateNewOrgAdmin() {

  const {
    show,
    sendEmailApiResponse,
    handleClose,
    handleShow,
    handleOnInvite,
    handleNameChange,
    handleEmailChange,
    emailError,
    nameError
  } = useCreateNewOrgAdmin();

  useSpinner(sendEmailApiResponse.status);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        <PlusIconWhite />
        <span>Add Org Admin</span>
      </Button>

      <Modal show={show} onHide={handleClose} className="modal-container create-new-org-admin" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Org Admin</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleOnInvite}>

          <Modal.Body>
            <div className='add-group-container'>
              <div className='create-new-org-admin'>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Organization Name</Form.Label>
                  <Form.Control type="text"
                    placeholder="Boise State University"
                    onChange={handleNameChange}
                    required />
                     {nameError && <p style={{ color: "red" }}>{nameError}</p>}
                </Form.Group>
              

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Organization Admin Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="example@email.com"
                    onChange={handleEmailChange}
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    required />
                    {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                </Form.Group>
                
              </div>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <Button className='btn-cancel' onClick={handleClose}>
              Cancel
            </Button>
            <Button className='btn-style' type="submit" disabled={!!emailError || !!nameError}>
              Invite
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

    </>
  );
}

export default Modal4CreateNewOrgAdmin;